<template>
  <cms-util-link :url="url" class="link-text d-flex flex-column" target="_self">
    <base-image
      :url="src"
      alt=""
      :init-height="90"
      loading="lazy"
      height="90"
      style="height: auto; width: 100%"
    />
    <div class="text-center font-weight-bold text-h4 pa-3" :class="textClass">
      <slot></slot>
    </div>
  </cms-util-link>
</template>

<script>
import BaseImage from '~/components/base/image/BaseImage'
export default {
  name: 'NavigatorHighlightBox',
  components: { BaseImage },
  props: {
    url: {
      type: String,
      default: undefined,
    },
    src: {
      type: String,
      default: undefined,
    },
    textClass: {
      type: String,
      default: undefined,
    },
  },
}
</script>
